import axios from "axios";
import API from "../helpers/api";
import { toast } from "react-toastify";
let searchData = {
    Name: '',
    PageNumber: 1,
    PageSize: 25
}
export const getKeywordList = (item) => {
    let url = `${API.Keywordlist}?Name=${item.Name}&PageNumber=${item.PageNumber}&PageSize=${item.PageSize}`;
    return dispatch => {
        axios.get(url)
            .then((response) => {
                dispatch({
                    type: "getKeywordListSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "getKeywordListFailure",
                    error: "ERROR"
                })
            })
    }
}
export const postKeywordList = (data) => {
    let url = `${API.postKeyword}`;
    return dispatch => {
        axios.post(url, data)
            .then((response) => {
                if (response.data) {
                    toast.success('Added Successfully', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    dispatch(getKeywordList(searchData));
                }
                dispatch({
                    type: "postKeywordSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "postKeywordFailure",
                    error: "ERROR"
                })
            })
    }
}
export const putKeywordList = (data) => {
    let url = `${API.postKeyword}`;
    return dispatch => {
        axios.put(url, data)
            .then((response) => {
                if (response.data) {
                    toast.success('Updated Successfully', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    dispatch(getKeywordList(searchData));
                }
                dispatch({
                    type: "updateKeywordSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "updateKeywordFailure",
                    error: "ERROR"
                })
            })
    }
}
export const deleteKeywordList = (data) => {
    let url = `${API.postKeyword}`;
    return dispatch => {
        axios.put(url, data)
            .then((response) => {
                if (response.data) {
                    toast.success('Deleted Successfully', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    dispatch(getKeywordList(searchData));
                }
                dispatch({
                    type: "deleteKeywordSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "deleteKeywordFailure",
                    error: "ERROR"
                })
            })
    }
}

